import {MyMahiService} from "../../service/MyMahiService";
import {useCallback, useState} from "react";
import {MyMahiStatusType} from "../../domain/verification/MyMahiStatusType";

export const MyMahiViewModel = () => {

    const [loading, setLoading] = useState<boolean>(false);
    const [url, setUrl] = useState<string>();
    const [status, setStatus] = useState<MyMahiStatusType>(MyMahiStatusType.PENDING);

    const requestVerification = async (verificationId: string): Promise<string> => {
        setLoading(true)
        const service = MyMahiService.getInstance()
        const response = await service.requestVerification(verificationId)
        setUrl(response)
        setLoading(false)
        return response
    }

    const retrieveVerificationStatus = useCallback(async (verificationId: string) => {
        const service = MyMahiService.getInstance()
        const response = await service.retrieveVerificationStatus(verificationId)
        setStatus(response)
    }, [])

    const retrieveVerificationUrl = useCallback(async (verificationId: string) => {
        const service = MyMahiService.getInstance()
        const response = await service.retrieveVerificationUrl(verificationId)
        setUrl(response)
    }, [])

    const cancelVerificationRequest = async (verificationId: string) => {
        const service = MyMahiService.getInstance()
        await service.cancelVerification(verificationId)
    }

    return {
        url,
        status,
        loading,
        requestVerification,
        retrieveVerificationStatus,
        retrieveVerificationUrl,
        cancelVerificationRequest
    }

}